/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Done_BodyInputs */



/**
* | output |
* | --- |
* | "The recording is finished. The transcript sits with the report." |
*
* @param {Meeting_Offline_Done_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_done_body = /** @type {((inputs?: Meeting_Offline_Done_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Done_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De opname is afgerond. Het transcript staat bij het verslag.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'enregistrement est terminé. La transcription se trouve avec le compte rendu.")
	return /** @type {LocalizedString} */ ("The recording is finished. The transcript sits with the report.")
});